<template>
  <aiInfoTable
    ref="table"
    :aiHeaders="aiHeaders"
    apiUrl="/v2/ai/get-all-features"
    :editable="false"
    :clientId="clientId"
    :filters="filters"
    :hide-header="true"
    data-testid="ai-features-tab"
  />
</template>

<script>
import aiInfoTable from '@/modules/admin/views/components/AiInfoTable.vue';
import varianceAnalysisConstants from '@/modules/varianceanalysis/constants.js';

export default {
  name: 'AiFeaturesTab',
  components: { aiInfoTable },
  data() {
    return {
      aiHeaders: [
        { text: 'Feature Name', value: 'feature_name', sortable: false, filterable: true },
        { text: 'Description', value: 'description', sortable: true, filterable: true },
        { text: 'Status', value: 'super_admin_enabled', sortable: false, filterable: true },
        { text: 'Prompt variants', value: 'prompt_variants_data', sortable: true, filterable: true },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      filters: {
        product: varianceAnalysisConstants.AI_FILTERS.PRODUCT,
        module: varianceAnalysisConstants.AI_FILTERS.MODULE,
      },
    };
  },
  computed: {
    clientId() {
      return this.$store.state.client || '';
    },
  },
};
</script>
